module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "car-block",
    on: {
      "click": function($event) {
        return _vm.gotoVehical(_vm.item.id)
      }
    }
  }, [_c('div', {
    staticClass: "car-image-container"
  }, [_c('img', {
    staticClass: "car-image",
    attrs: {
      "src": _vm.item.photos[0],
      "onerror": "this.src='https://vassstorage.blob.core.windows.net/salesraterprod/images/m_no_photo.png'"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "car-description"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), _c('div', {
    staticClass: "mobile-only"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Miles: ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.item.odometer))])]), _vm._v(" "), _c('div', {
    staticClass: "grid desktop-only"
  }, [_c('div', {
    staticClass: "grid-column"
  }, [_c('div', {
    staticClass: "bold"
  }, [_vm._v("Year")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.item.year))])]), _vm._v(" "), _c('div', {
    staticClass: "grid-column"
  }, [_c('div', {
    staticClass: "bold"
  }, [_vm._v("Miles")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.item.odometer))])]), _vm._v(" "), _c('div', {
    staticClass: "grid-column"
  }, [_c('div', {
    staticClass: "bold"
  }, [_vm._v("Drivetrain")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.item.driveTrain))])]), _vm._v(" "), _c('div', {
    staticClass: "grid-column"
  }, [_c('div', {
    staticClass: "bold"
  }, [_vm._v("Transmission")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.item.transmission))])]), _vm._v(" "), _c('div', {
    staticClass: "grid-column"
  }, [_c('div', {
    staticClass: "bold"
  }, [_vm._v("Engine")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.item.engine))])])]), _vm._v(" "), _c('div', {
    staticClass: "price-container"
  }, [_c('div', {
    staticClass: "price",
    style: (_vm.borderStyle)
  }, [_c('span', [_vm._v(_vm._s(_vm.finalPrice(_vm.item.price, _vm.item.msrp)))])]), _vm._v(" "), _vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "price-label"
  }, [_c('i', {
    staticClass: "fas fa-info-circle"
  }), _vm._v("\n        Excludes taxes and Fees\n      ")])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-222b6289", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-222b6289"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/components/inventory/inventory-list-item.vue
// module id = 750
// module chunks = 0